module.exports = __webpack_public_path__ + "static/salon-pasajeros---iluminacion-7103a7ec599c2930701f7298ff2a4c15.jpg";